/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Game studio API
 * Game studio API documentation OAS.
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BetPickemCommand,
  BetsPickemCommand,
  GetApiPickemsCurrentPlayerAllParams,
  GetApiPickemsCurrentPlayerBetableParams,
  GetApiPickemsCurrentPlayerHistoryParams,
  GetApiPickemsPlayerLeaderboardsParams,
  GetApiPickemsPlayerResultsParams,
  GetApiPickemsPlayerTournamentLeaderboardsParams,
  PickemDtoPaginatedList,
  PlayerPickemDtoPaginatedList,
  PlayerPickemGroupDto,
  PlayersLeaderboardAlltimeDtoPaginatedList,
  PlayersLeaderboardDtoPaginatedList
} from '../../backoffice-schemas';

import putApiPickemsBetMutator from '../../../lib/customInstance';
import putApiPickemsBetsMutator from '../../../lib/customInstance';
import getApiPickemsCurrentPlayerAllMutator from '../../../lib/customInstance';
import getApiPickemsCurrentPlayerHistoryMutator from '../../../lib/customInstance';
import getApiPickemsCurrentPlayerBetableMutator from '../../../lib/customInstance';
import getApiPickemsPlayerResultsMutator from '../../../lib/customInstance';
import getApiPickemsPlayerLeaderboardsMutator from '../../../lib/customInstance';
import getApiPickemsPlayerTournamentLeaderboardsMutator from '../../../lib/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const putApiPickemsBet = (
    betPickemCommand: BetPickemCommand,
 options?: SecondParameter<typeof putApiPickemsBetMutator>,) => {
      
      
      return putApiPickemsBetMutator<null>(
      {url: `https://api.gocore.gg/api/Pickems/bet`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: betPickemCommand
    },
      options);
    }
  


export const getPutApiPickemsBetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiPickemsBet>>, TError,{data: BetPickemCommand}, TContext>, request?: SecondParameter<typeof putApiPickemsBetMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiPickemsBet>>, TError,{data: BetPickemCommand}, TContext> => {

const mutationKey = ['putApiPickemsBet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiPickemsBet>>, {data: BetPickemCommand}> = (props) => {
          const {data} = props ?? {};

          return  putApiPickemsBet(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiPickemsBetMutationResult = NonNullable<Awaited<ReturnType<typeof putApiPickemsBet>>>
    export type PutApiPickemsBetMutationBody = BetPickemCommand
    export type PutApiPickemsBetMutationError = unknown

    export const usePutApiPickemsBet = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiPickemsBet>>, TError,{data: BetPickemCommand}, TContext>, request?: SecondParameter<typeof putApiPickemsBetMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiPickemsBet>>,
        TError,
        {data: BetPickemCommand},
        TContext
      > => {

      const mutationOptions = getPutApiPickemsBetMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const putApiPickemsBets = (
    betsPickemCommand: BetsPickemCommand,
 options?: SecondParameter<typeof putApiPickemsBetsMutator>,) => {
      
      
      return putApiPickemsBetsMutator<null>(
      {url: `https://api.gocore.gg/api/Pickems/bets`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: betsPickemCommand
    },
      options);
    }
  


export const getPutApiPickemsBetsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiPickemsBets>>, TError,{data: BetsPickemCommand}, TContext>, request?: SecondParameter<typeof putApiPickemsBetsMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiPickemsBets>>, TError,{data: BetsPickemCommand}, TContext> => {

const mutationKey = ['putApiPickemsBets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiPickemsBets>>, {data: BetsPickemCommand}> = (props) => {
          const {data} = props ?? {};

          return  putApiPickemsBets(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiPickemsBetsMutationResult = NonNullable<Awaited<ReturnType<typeof putApiPickemsBets>>>
    export type PutApiPickemsBetsMutationBody = BetsPickemCommand
    export type PutApiPickemsBetsMutationError = unknown

    export const usePutApiPickemsBets = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiPickemsBets>>, TError,{data: BetsPickemCommand}, TContext>, request?: SecondParameter<typeof putApiPickemsBetsMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiPickemsBets>>,
        TError,
        {data: BetsPickemCommand},
        TContext
      > => {

      const mutationOptions = getPutApiPickemsBetsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getApiPickemsCurrentPlayerAll = (
    params?: GetApiPickemsCurrentPlayerAllParams,
 options?: SecondParameter<typeof getApiPickemsCurrentPlayerAllMutator>,signal?: AbortSignal
) => {
      
      
      return getApiPickemsCurrentPlayerAllMutator<PlayerPickemDtoPaginatedList>(
      {url: `https://api.gocore.gg/api/Pickems/current-player/all`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiPickemsCurrentPlayerAllQueryKey = (params?: GetApiPickemsCurrentPlayerAllParams,) => {
    return [`https://api.gocore.gg/api/Pickems/current-player/all`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiPickemsCurrentPlayerAllQueryOptions = <TData = Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>, TError = unknown>(params?: GetApiPickemsCurrentPlayerAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsCurrentPlayerAllMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPickemsCurrentPlayerAllQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>> = ({ signal }) => getApiPickemsCurrentPlayerAll(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPickemsCurrentPlayerAllQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>>
export type GetApiPickemsCurrentPlayerAllQueryError = unknown


export function useGetApiPickemsCurrentPlayerAll<TData = Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>, TError = unknown>(
 params: undefined |  GetApiPickemsCurrentPlayerAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>,
          TError,
          Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiPickemsCurrentPlayerAllMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPickemsCurrentPlayerAll<TData = Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>, TError = unknown>(
 params?: GetApiPickemsCurrentPlayerAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>,
          TError,
          Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiPickemsCurrentPlayerAllMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPickemsCurrentPlayerAll<TData = Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>, TError = unknown>(
 params?: GetApiPickemsCurrentPlayerAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsCurrentPlayerAllMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPickemsCurrentPlayerAll<TData = Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>, TError = unknown>(
 params?: GetApiPickemsCurrentPlayerAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerAll>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsCurrentPlayerAllMutator>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPickemsCurrentPlayerAllQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiPickemsCurrentPlayerHistory = (
    params?: GetApiPickemsCurrentPlayerHistoryParams,
 options?: SecondParameter<typeof getApiPickemsCurrentPlayerHistoryMutator>,signal?: AbortSignal
) => {
      
      
      return getApiPickemsCurrentPlayerHistoryMutator<PlayerPickemGroupDto[]>(
      {url: `https://api.gocore.gg/api/Pickems/current-player/history`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiPickemsCurrentPlayerHistoryQueryKey = (params?: GetApiPickemsCurrentPlayerHistoryParams,) => {
    return [`https://api.gocore.gg/api/Pickems/current-player/history`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiPickemsCurrentPlayerHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>, TError = unknown>(params?: GetApiPickemsCurrentPlayerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsCurrentPlayerHistoryMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPickemsCurrentPlayerHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>> = ({ signal }) => getApiPickemsCurrentPlayerHistory(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPickemsCurrentPlayerHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>>
export type GetApiPickemsCurrentPlayerHistoryQueryError = unknown


export function useGetApiPickemsCurrentPlayerHistory<TData = Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>, TError = unknown>(
 params: undefined |  GetApiPickemsCurrentPlayerHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiPickemsCurrentPlayerHistoryMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPickemsCurrentPlayerHistory<TData = Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>, TError = unknown>(
 params?: GetApiPickemsCurrentPlayerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiPickemsCurrentPlayerHistoryMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPickemsCurrentPlayerHistory<TData = Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>, TError = unknown>(
 params?: GetApiPickemsCurrentPlayerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsCurrentPlayerHistoryMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPickemsCurrentPlayerHistory<TData = Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>, TError = unknown>(
 params?: GetApiPickemsCurrentPlayerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerHistory>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsCurrentPlayerHistoryMutator>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPickemsCurrentPlayerHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiPickemsCurrentPlayerBetable = (
    params?: GetApiPickemsCurrentPlayerBetableParams,
 options?: SecondParameter<typeof getApiPickemsCurrentPlayerBetableMutator>,signal?: AbortSignal
) => {
      
      
      return getApiPickemsCurrentPlayerBetableMutator<PickemDtoPaginatedList>(
      {url: `https://api.gocore.gg/api/Pickems/current-player/betable`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiPickemsCurrentPlayerBetableQueryKey = (params?: GetApiPickemsCurrentPlayerBetableParams,) => {
    return [`https://api.gocore.gg/api/Pickems/current-player/betable`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiPickemsCurrentPlayerBetableQueryOptions = <TData = Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>, TError = unknown>(params?: GetApiPickemsCurrentPlayerBetableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsCurrentPlayerBetableMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPickemsCurrentPlayerBetableQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>> = ({ signal }) => getApiPickemsCurrentPlayerBetable(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPickemsCurrentPlayerBetableQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>>
export type GetApiPickemsCurrentPlayerBetableQueryError = unknown


export function useGetApiPickemsCurrentPlayerBetable<TData = Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>, TError = unknown>(
 params: undefined |  GetApiPickemsCurrentPlayerBetableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>,
          TError,
          Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiPickemsCurrentPlayerBetableMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPickemsCurrentPlayerBetable<TData = Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>, TError = unknown>(
 params?: GetApiPickemsCurrentPlayerBetableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>,
          TError,
          Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiPickemsCurrentPlayerBetableMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPickemsCurrentPlayerBetable<TData = Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>, TError = unknown>(
 params?: GetApiPickemsCurrentPlayerBetableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsCurrentPlayerBetableMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPickemsCurrentPlayerBetable<TData = Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>, TError = unknown>(
 params?: GetApiPickemsCurrentPlayerBetableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsCurrentPlayerBetable>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsCurrentPlayerBetableMutator>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPickemsCurrentPlayerBetableQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiPickemsPlayerResults = (
    params?: GetApiPickemsPlayerResultsParams,
 options?: SecondParameter<typeof getApiPickemsPlayerResultsMutator>,signal?: AbortSignal
) => {
      
      
      return getApiPickemsPlayerResultsMutator<PlayersLeaderboardDtoPaginatedList>(
      {url: `https://api.gocore.gg/api/Pickems/player-results`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiPickemsPlayerResultsQueryKey = (params?: GetApiPickemsPlayerResultsParams,) => {
    return [`https://api.gocore.gg/api/Pickems/player-results`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiPickemsPlayerResultsQueryOptions = <TData = Awaited<ReturnType<typeof getApiPickemsPlayerResults>>, TError = unknown>(params?: GetApiPickemsPlayerResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerResults>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsPlayerResultsMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPickemsPlayerResultsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPickemsPlayerResults>>> = ({ signal }) => getApiPickemsPlayerResults(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPickemsPlayerResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPickemsPlayerResults>>>
export type GetApiPickemsPlayerResultsQueryError = unknown


export function useGetApiPickemsPlayerResults<TData = Awaited<ReturnType<typeof getApiPickemsPlayerResults>>, TError = unknown>(
 params: undefined |  GetApiPickemsPlayerResultsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPickemsPlayerResults>>,
          TError,
          Awaited<ReturnType<typeof getApiPickemsPlayerResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiPickemsPlayerResultsMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPickemsPlayerResults<TData = Awaited<ReturnType<typeof getApiPickemsPlayerResults>>, TError = unknown>(
 params?: GetApiPickemsPlayerResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPickemsPlayerResults>>,
          TError,
          Awaited<ReturnType<typeof getApiPickemsPlayerResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiPickemsPlayerResultsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPickemsPlayerResults<TData = Awaited<ReturnType<typeof getApiPickemsPlayerResults>>, TError = unknown>(
 params?: GetApiPickemsPlayerResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerResults>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsPlayerResultsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPickemsPlayerResults<TData = Awaited<ReturnType<typeof getApiPickemsPlayerResults>>, TError = unknown>(
 params?: GetApiPickemsPlayerResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerResults>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsPlayerResultsMutator>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPickemsPlayerResultsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiPickemsPlayerLeaderboards = (
    params?: GetApiPickemsPlayerLeaderboardsParams,
 options?: SecondParameter<typeof getApiPickemsPlayerLeaderboardsMutator>,signal?: AbortSignal
) => {
      
      
      return getApiPickemsPlayerLeaderboardsMutator<PlayersLeaderboardAlltimeDtoPaginatedList>(
      {url: `https://api.gocore.gg/api/Pickems/player-leaderboards`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiPickemsPlayerLeaderboardsQueryKey = (params?: GetApiPickemsPlayerLeaderboardsParams,) => {
    return [`https://api.gocore.gg/api/Pickems/player-leaderboards`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiPickemsPlayerLeaderboardsQueryOptions = <TData = Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>, TError = unknown>(params?: GetApiPickemsPlayerLeaderboardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsPlayerLeaderboardsMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPickemsPlayerLeaderboardsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>> = ({ signal }) => getApiPickemsPlayerLeaderboards(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPickemsPlayerLeaderboardsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>>
export type GetApiPickemsPlayerLeaderboardsQueryError = unknown


export function useGetApiPickemsPlayerLeaderboards<TData = Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>, TError = unknown>(
 params: undefined |  GetApiPickemsPlayerLeaderboardsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>,
          TError,
          Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiPickemsPlayerLeaderboardsMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPickemsPlayerLeaderboards<TData = Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>, TError = unknown>(
 params?: GetApiPickemsPlayerLeaderboardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>,
          TError,
          Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiPickemsPlayerLeaderboardsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPickemsPlayerLeaderboards<TData = Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>, TError = unknown>(
 params?: GetApiPickemsPlayerLeaderboardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsPlayerLeaderboardsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPickemsPlayerLeaderboards<TData = Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>, TError = unknown>(
 params?: GetApiPickemsPlayerLeaderboardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerLeaderboards>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsPlayerLeaderboardsMutator>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPickemsPlayerLeaderboardsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiPickemsPlayerTournamentLeaderboards = (
    params?: GetApiPickemsPlayerTournamentLeaderboardsParams,
 options?: SecondParameter<typeof getApiPickemsPlayerTournamentLeaderboardsMutator>,signal?: AbortSignal
) => {
      
      
      return getApiPickemsPlayerTournamentLeaderboardsMutator<PlayersLeaderboardDtoPaginatedList>(
      {url: `https://api.gocore.gg/api/Pickems/player-tournament-leaderboards`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiPickemsPlayerTournamentLeaderboardsQueryKey = (params?: GetApiPickemsPlayerTournamentLeaderboardsParams,) => {
    return [`https://api.gocore.gg/api/Pickems/player-tournament-leaderboards`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiPickemsPlayerTournamentLeaderboardsQueryOptions = <TData = Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>, TError = unknown>(params?: GetApiPickemsPlayerTournamentLeaderboardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsPlayerTournamentLeaderboardsMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPickemsPlayerTournamentLeaderboardsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>> = ({ signal }) => getApiPickemsPlayerTournamentLeaderboards(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPickemsPlayerTournamentLeaderboardsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>>
export type GetApiPickemsPlayerTournamentLeaderboardsQueryError = unknown


export function useGetApiPickemsPlayerTournamentLeaderboards<TData = Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>, TError = unknown>(
 params: undefined |  GetApiPickemsPlayerTournamentLeaderboardsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>,
          TError,
          Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiPickemsPlayerTournamentLeaderboardsMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPickemsPlayerTournamentLeaderboards<TData = Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>, TError = unknown>(
 params?: GetApiPickemsPlayerTournamentLeaderboardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>,
          TError,
          Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiPickemsPlayerTournamentLeaderboardsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPickemsPlayerTournamentLeaderboards<TData = Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>, TError = unknown>(
 params?: GetApiPickemsPlayerTournamentLeaderboardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsPlayerTournamentLeaderboardsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPickemsPlayerTournamentLeaderboards<TData = Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>, TError = unknown>(
 params?: GetApiPickemsPlayerTournamentLeaderboardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPickemsPlayerTournamentLeaderboards>>, TError, TData>>, request?: SecondParameter<typeof getApiPickemsPlayerTournamentLeaderboardsMutator>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPickemsPlayerTournamentLeaderboardsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



